module.exports = __webpack_public_path__ + "img/icon-4.29f1b13c.svg";